import React from 'react'

interface IStepperContextState {
  step: number
  progress: { total: number, answered: number }
  setStep: React.Dispatch<React.SetStateAction<IStepperContextState['step']>>
  setProgress: React.Dispatch<React.SetStateAction<IStepperContextState['progress']>>
}

const initialState: IStepperContextState = {
  step: 0,
  progress: { total: 1, answered: 0 },
  setStep: () => {},
  setProgress: () => {}
}

const StepperContext = React.createContext<IStepperContextState>(initialState)

export const StepperContextProvider = (props: React.PropsWithChildren): JSX.Element => {
  const [step, setStep] = React.useState<IStepperContextState['step']>(initialState.step)
  const [progress, setProgress] = React.useState<IStepperContextState['progress']>(initialState.progress)

  return <StepperContext.Provider value={{ step, progress, setStep, setProgress }} >{props.children}</StepperContext.Provider>
}

export const useStepper = (): IStepperContextState => React.useContext(StepperContext)
